import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../molecules/Icon';

const InfoMessage = ({ message }) => (
  <div className="message-wrapper">
    <p className="message-wrapper--paragraph">
      <Icon icon="info" alt="Information" />
      <span className="message-wrapper--text">
        {message}
      </span>
    </p>
  </div>
);

InfoMessage.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
};

InfoMessage.defaultProps = {
  message: '',
};

export default InfoMessage;



// WEBPACK FOOTER //
// src/components/atoms/InfoMessage/index.jsx